import { connect } from "@formily/react";

export const RumbleFormDecorator = connect((props) => {
  return (
    <div className="rumble-form-decorator" {...props}>
      {props.children}
    </div>
  );
});
